import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatiteAEditComponent.vue?vue&type=template&id=42718d36"
import script from "./IndagineEpidemiologicaEpatiteAEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatiteAEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports